import { useState } from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';
import { surahs } from '../../data/quranData';

const { FiSearch } = FiIcons;

const SurahList = ({ onSurahSelect, selectedSurah, filterSurahIds = null }) => {
    const [searchTerm, setSearchTerm] = useState('');

    // First filter by IDs if provided (for playlists), then by search term
    const displayedSurahs = surahs.filter(surah => {
        if (filterSurahIds && !filterSurahIds.includes(surah.number)) {
            return false;
        }
        return true;
    });

    const filteredSurahs = displayedSurahs.filter(surah =>
        surah.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
        surah.meaning.toLowerCase().includes(searchTerm.toLowerCase()) ||
        String(surah.number).includes(searchTerm)
    );

    return (
        <div className="bg-white dark:bg-gray-800 rounded-xl border border-gray-200 dark:border-gray-700 h-80 lg:h-full flex flex-col shadow-sm">
            {/* Search */}
            <div className="p-2 border-b border-gray-200 dark:border-gray-700 shrink-0">
                <div className="relative">
                    <SafeIcon
                        icon={FiSearch}
                        className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 w-4 h-4"
                    />
                    <input
                        type="text"
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                        placeholder="Search..."
                        className="w-full pl-9 pr-3 py-1.5 text-sm bg-gray-50 dark:bg-gray-700 border border-gray-200 dark:border-gray-600 rounded-lg focus:outline-none focus:ring-2 focus:ring-emerald-500 text-gray-900 dark:text-gray-100 placeholder-gray-500 dark:placeholder-gray-400"
                    />
                </div>
            </div>

            {/* Surah List */}
            <div className="overflow-y-auto flex-1 custom-scrollbar">
                {filteredSurahs.length === 0 ? (
                    <div className="p-4 text-center text-gray-500 dark:text-gray-400 text-sm">
                        No Surahs found
                    </div>
                ) : (
                    filteredSurahs.map((surah, index) => (
                        <motion.div
                            key={surah.number}
                            initial={{ opacity: 0, x: -10 }}
                            animate={{ opacity: 1, x: 0 }}
                            transition={{ delay: 0.01 * Math.min(index, 30) }}
                            onClick={() => onSurahSelect(surah)}
                            className={`px-3 py-1.5 border-b border-gray-100 dark:border-gray-700 cursor-pointer hover:bg-gray-50 dark:hover:bg-gray-700 transition-colors ${selectedSurah?.number === surah.number ? 'bg-emerald-50 dark:bg-emerald-900/20 border-l-4 border-l-emerald-500' : 'border-l-4 border-l-transparent'
                                }`}
                        >
                            <div className="flex items-center justify-between">
                                <div className="flex items-center space-x-2 overflow-hidden">
                                    <div className={`w-6 h-6 rounded-full flex items-center justify-center text-xs font-semibold shrink-0 ${selectedSurah?.number === surah.number ? 'bg-emerald-600 text-white' : 'bg-gray-200 dark:bg-gray-700 text-gray-600 dark:text-gray-300'
                                        }`}>
                                        {surah.number}
                                    </div>
                                    <div className="min-w-0">
                                        <h3 className={`font-medium truncate text-sm ${selectedSurah?.number === surah.number ? 'text-emerald-700 dark:text-emerald-400' : 'text-gray-900 dark:text-gray-200'}`}>
                                            {surah.name}
                                        </h3>
                                        <div className="flex items-center text-[10px] text-gray-500 dark:text-gray-400 space-x-1">
                                            <span className="truncate max-w-[80px]">{surah.meaning}</span>
                                        </div>
                                    </div>
                                </div>
                                <div className="text-right shrink-0">
                                    <div className="text-sm font-arabic text-gray-800 dark:text-gray-200 leading-none mb-1">
                                        {surah.arabicName}
                                    </div>
                                    <div className="text-[10px] text-gray-400">
                                        {surah.verses}v
                                    </div>
                                </div>
                            </div>
                        </motion.div>
                    ))
                )}
            </div>
        </div>
    );
};

export default SurahList;